/**
 * @file: useDefaultPreInspectionAnnotationTag.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useStoreConfiguration } from '@euler/functions/useStoreConfiguration';
import { useCallback } from 'react';

export const useDefaultPreInspectionAnnotationTag = () => {
  const storeConfiguration = useStoreConfiguration();
  const autoDisabled =
    storeConfiguration.app?.autoAnnotationTagForPreInspectionDisabled === true;
  return useCallback(
    (isRecordSite?: boolean) => {
      return isRecordSite || autoDisabled ? undefined : '损伤';
    },
    [autoDisabled],
  );
};
